module.exports = __webpack_public_path__ + "static/media/methai.b3be046e.png";